<style lang="scss">
.round-select {
  display: inline-block;

  .el-select__caret {
    color: #fff !important;
  }

  .el-select {
    width: 96px;

    .el-input {
      .el-input__inner {
        color: #fff;
        text-align: center;
        border-radius: 20px;
        border: 0;
        background: $color-theme;
      }
    }
  }
}

.video-dialog {
  .el-dialog__body {
    padding: 0;
    background-color: #0f0f0f;
  }
}

.el-dialog .el-dialog__header {
  height: auto;
  line-height: unset;
}

.home-x.index_route .container {
  padding-top: 54px !important;
}
</style>

<style scoped lang="scss">
.wrapper {
  display: flex;
  min-height: calc(100vh - 115px);

  .content-left {
    flex: 1;
    width: 0;
    margin-top: 24px;
    margin-bottom: 24px;

    .card {
      background: #fff;
      margin: 12px 0;
      border-radius: 4px;
      box-shadow: 0px 1px 2px 0px rgba(204, 204, 204, 0.5);

      .header-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 10px;

        > h3 {
          padding: 0 10px;
          height: 40px;
          line-height: 44px;
          font-size: 16px;
          color: $color-text;

          &:before {
            margin-top: -4px;
            display: inline-block;
            content: "";
            width: 4px;
            height: 20px;
            vertical-align: middle;
            background: $color-theme;
            border-radius: 10px;
            margin-right: 10px;
          }
        }
      }

      .exam-footer {
        padding: 10px 0;
        text-align: center;
        position: relative;

        i {
          display: inline-block;
          width: 20px;
          height: 8px;
          background-color: #6dc171;
          margin-right: 10px;
        }

        span {
          font-size: $font-size-small;
          color: #999999;
        }

        p {
          position: absolute;
          right: 15px;
          bottom: 10px;
          display: inline-block;
          font-size: 12px;
          color: #333;

          &:hover {
            color: $color-theme;
            cursor: pointer;
          }
        }
      }
    }

    .card-first {
      height: 50px;
      line-height: 50px;
      display: flex;

      time {
        flex: 1;
        padding: 0 10px;
        color: #666;
        font-size: 14px;
      }

      .select {
        margin: 0 10px;
      }
    }

    .card-second {
      padding-bottom: 8px;

      .header-wrap {
        position: relative;

        .el-button {
          position: absolute;
          right: 15px;
          top: 15px;
        }
      }

      .exam-header {
        position: relative;

        > h2 {
          padding: 6px;
          font-size: 22px;
          font-weight: bold;
          text-align: center;
          color: #333;
        }

        > p {
          padding: 8px;
          height: 20px;
          line-height: 20px;
          vertical-align: middle;
          text-align: center;
          font-size: 14px;
          color: #999;

          img {
            padding-right: 4px;
            vertical-align: middle;
          }
        }

        span {
          display: inline-block;
          background-color: rgba(248, 249, 251, 1);
          padding: 3px 8px;
          color: #2877ff;
          margin-right: 10px;
        }
      }

      .exam-content {
        display: flex;
        margin: 20px 35px;

        > li {
          flex: 1;
          border-right: 1px solid #e2e3e3;
          padding: 0 20px;
          text-align: center;

          &:last-child {
            border-right: none;
          }

          .exam-inner {
            display: inline-block;
            text-align: left;
            width: 160px;
            white-space: nowrap;
          }

          h5 {
            color: #666;
            font-size: 16px;
          }

          .data {
            padding: 16px 0;
            vertical-align: bottom;

            span {
              font-size: 38px;
              color: #71d376;
              font-weight: bold;
              display: inline-block;
            }

            label {
              display: inline-block;
              font-size: 18px;
              color: #666;
            }
          }

          p {
            span {
              font-size: 14px;
              color: #666;
            }

            label {
              font-size: 15px;
              color: #2877ff;
            }
          }
        }
      }
    }

    .card-three {
      padding-bottom: 20px;

      #scoreLine {
        height: 300px;
        width: 100%;
        padding-right: 15px;
        box-sizing: border-box;
      }
    }

    // 无数据
    .no-data {
      height: 200px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 100px;
        height: 79px;
      }

      p {
        padding-left: 32px;
        color: #999;
      }
    }
  }

  .content-right {
    padding-right: 10px;
    width: 280px;
    padding: 24px;

    .message {
      padding: 24px;
      background: #ffffff;
      border-radius: 8px;
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .info-thrid {
        position: relative;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        width: 220px;
        height: 180px;
        border-radius: 5px;
        margin: -10px 0 15px 0;
        background: $color-theme;
        box-shadow: $box-shadow;

        .tip {
          color: #fff;
          font-size: 12px;
          line-height: 18px;
          user-select: none;
          text-align: center;
          margin-top: 126px;
        }
      }

      .info {
        .head {
          display: flex;
          margin-bottom: 16px;

          .name {
            font-size: 16px;
            color: #303233;
            display: flex;
            align-items: center;
            margin-left: 16px;
            font-weight: bold;
          }

          .role,
          .school {
            width: 100%;
            font-size: 14px;
            color: #303233;

            span:nth-child(1) {
              color: #616366;
            }
          }
        }

        .ms-item {
          display: flex;
          font-size: 14px;
          margin-bottom: 16px;
          color: #303233;

          span:nth-child(1) {
            color: #616366;
            width: 42px;
          }

          span:nth-child(2) {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            flex: 1;
          }
        }

        .btns {
          margin-top: 4px;
          display: flex;
          justify-content: space-between;

          .el-button {
            width: 146px;
            height: 50px;
          }
        }
      }
    }

    .profile {
      margin: 12px 0;
      border-radius: 2px;
      min-height: 292px;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      box-shadow: 0px 1px 2px 0px rgba(204, 204, 204, 0.5);

      .avatar {
        border-radius: 50%;
        margin: 10px;
        background: #fff;
      }

      .el-button {
        margin: 6px 0;
      }
    }

    .backlog {
      margin: 12px 0;
      border-radius: 2px;
      min-height: 120px;
      background: #fff;
      box-shadow: 0px 1px 2px 0px rgba(204, 204, 204, 0.5);

      .backlog-header {
        color: #666;
        height: 40px;
        line-height: 40px;
        padding: 0 8px;
        font-size: 16px;
        border-radius: 2px 2px 0 0;
        background: #f9fafc;
      }

      .backlog-content {
        padding: 0 15px 8px;

        .title {
          height: 40px;
          line-height: 40px;
          display: flex;
          vertical-align: middle;
          cursor: pointer;

          h4 {
            font-size: 14px;
            color: #666;
            flex: 1;
          }

          span {
            color: #666;
            font-size: 14px;

            &.has-count {
              color: #ff0000;
            }
          }

          label {
            width: 26px;
            text-align: center;
            margin-top: -1px;

            img {
              opacity: 0.5;
              display: inline-block;
              transition: all 0.2s;
            }
          }
        }

        .content {
          padding: 6px 10px;
          background: #f5f5f5;

          > li {
            padding: 4px 0 4px;
            color: #2877ff;
            font-size: 14px;
            line-height: 18px;
          }
        }
      }
    }

    .tutorial {
      display: flex;
      flex-direction: column;
      min-height: 80px !important;

      .backlog-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #333;
        padding: 0 15px;

        img {
          vertical-align: middle;
          margin-right: 5px;
        }

        .more {
          color: $color-theme;
          font-size: 12px;
          cursor: pointer;
        }

        span {
          font-size: 14px;
          vertical-align: -2px;
        }

        i {
          cursor: pointer;
        }
      }

      .backlog-content {
        padding: 0;

        .video-list {
          padding: 15px;

          li {
            padding: 5px 0;
            font-size: $font-size-small;

            img {
              vertical-align: middle;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
}

.test-box {
  p {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
  }

  .point {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 5px;
    display: inline-block;
  }

  .type-tips {
    height: 12px;
    font-size: 12px;
    color: #999;
    margin: 15px 0 20px;
  }
}

.fade-right-enter-active {
  transition: all 0.3s ease;
}

.fade-right-enter {
  transform: translate(20px, -20px);
  opacity: 0;
}

.fade-left-enter-active {
  transition: all 0.3s ease;
}

.fade-left-enter {
  transform: translate(-20px, -20px);
  opacity: 0;
}

.act {
  color: #2877ff;
}

.info-thrid {
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 220px;
  height: 180px;
  border-radius: 5px;
  margin: -10px 0 15px 0;
  background: $color-theme;
  box-shadow: $box-shadow;

  .tip {
    color: #fff;
    font-size: 12px;
    line-height: 18px;
    user-select: none;
    text-align: center;
    margin-top: 126px;
  }
}

.info-user {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  .head {
    display: flex;

    .name {
      font-size: 20px;
      color: #303233;
      display: flex;
      align-items: center;
    }

    .role,
    .school {
      width: 100%;
      font-size: 18px;
      color: #303233;

      span:nth-child(1) {
        color: #616366;
      }
    }
  }
}

.dot {
  margin-top: -20px;
}

.dot {
  animation: sploosh 1.5s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.dot2 {
  animation: sploosh2 1.5s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.dot3 {
  animation: sploosh3 1.5s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.dot,
.dot2,
.dot3 {
  height: 70px;
  width: 70px;
  font-size: 20px;
  color: #fff;
  line-height: 70px;
  text-align: center;
  border-radius: 100%;
  position: absolute;
  z-index: 10;
  animation-iteration-count: infinite;
  background: transparent;
}

@keyframes sploosh {
  0% {
    box-shadow: 0 0 0 0px rgba(255, 255, 255, 0.6);
    background: rgba(255, 255, 255, 0.6);
  }

  100% {
    box-shadow: 0 0 0 30px rgba(255, 255, 255, 0);
    background: rgba(255, 255, 255, 0);
  }
}

@keyframes sploosh2 {
  0% {
    box-shadow: 0 0 0 0px rgba(255, 255, 255, 0.6);
    background: rgba(255, 255, 255, 0.6);
  }

  100% {
    box-shadow: 0 0 0 15px rgba(255, 255, 255, 0);
    background: rgba(255, 255, 255, 0.3);
  }
}

@keyframes sploosh3 {
  0% {
    box-shadow: 0 0 0 0px rgba(255, 255, 255, 0.6);
    background: rgba(255, 255, 255, 0.6);
  }

  100% {
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
    background: rgba(255, 255, 255, 0);
  }
}

.lock-bg {
  margin: 10px;
  width: 50px;
  height: 50px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 50%;

  img {
    height: 30px;
    display: inline-block;
  }
}

.online-enter {
  display: inline-block;
  cursor: pointer;
  height: 165px;
  width: 100%;
  margin-top: 24px;

  img {
    border-radius: 6px;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
    width: 100%;
    height: 100%;
  }

  .close {
    position: absolute;
    height: 20px;
    width: 20px;
    top: -8px;
    right: -8px;
    z-index: 3;
    cursor: pointer;
  }
}

.video-help {
  display: flex;
  flex-direction: column;
  padding: 24px;
  box-sizing: border-box;
  margin-top: 24px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);

  .head {
    display: flex;
    justify-content: space-between;
    color: #000;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 24px;

    :nth-child(2) {
      color: #919599;
      font-size: 14px;
      cursor: pointer;
    }
  }

  .video {
    border-radius: 6px;
    height: 136px;
    margin-bottom: 12px;
    // background: url("~images/create-exam.png");
    background: rgb(180, 203, 240);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    line-height: 32px;
    color: white;
    font-size: 14px;
    position: relative;

    span {
      font-size: 20px;
    }

    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .toast {
    color: #2e3133;
    font-size: 14px;
  }
}

.dialog-content {
  padding: 40px 20px 20px;

  > h5 {
    height: 90px;
    line-height: 60px;
    color: $color-theme;
    font-size: 42px;
    text-align: center;
  }

  > p {
    text-align: center;
    line-height: 30px;
    font-size: 16px;
  }

  .tip {
    margin-top: 15px;
    // text-indent: 25px;
    text-align: left;
    font-size: 12px;
    color: #999;
  }
}
</style>

<template>
  <div class="wrapper">
    <transition name="fade-left">
      <div class="content-left">
        <entra-list />
      </div>
    </transition>
    <transition name="fade-right">
      <div class="content-right" v-show="cardRight">
        <div class="message">
          <div class="info">
            <div class="head">
              <img class="avatar" src="~images/avatar_default.png" width="70" height="70" />
              <span class="name">欢迎你，{{ userInfo.nickName }}</span>
            </div>
            <div class="ms-item">
              <span>学校：</span>
              <span :title="userInfo.schoolName">{{
                userInfo.schoolName
              }}</span>
            </div>
            <div class="ms-item">
              <span>角色：</span>
              <span :title="roleNameStr">{{ roleNameStr }}</span>
            </div>
            <div class="btns">
              <el-button type="primary" @click="$router.push('/v2/exam/create')">新建考试</el-button>
              <el-button type="warning" @click="$router.push('/v2/marking/index')">快捷批改</el-button>
            </div>
          </div>
        </div>
        <div class="video-help">
          <div class="head">
            <span>帮助中心</span>
            <span @click="toTutorial">更多</span>
          </div>
          <div class="video" @click="changeVideo(2)">
            <img src="~images/video-play.png" width="76px" height="76px" />
            <span>如何创建一场测验</span>
          </div>
          <span class="toast">操作教学视频(建议观看)</span>
        </div>
      </div>
    </transition>
    <!--播放视频-->
    <yue-dialog title="如何创建一场测验" :visible.sync="videoDialogVisible" @close="stopVideo" class="video-dialog">
      <video id="video" :src="videoSrc" controls="true" preload="meta" width="100%"></video>
    </yue-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NumberAnimated from "@/components/common/NumberAnimated";

export default {
  data () {
    return {
      createExamType: 2,
      isBankCenterTo: false,
      cardLeft: false,
      cardRight: false,
      countLoading: false, // 加载

      //基础指标趋势
      examTrendClass: {},
      trendLoading: false,

      date: "",
      schoolId: "",
      roleNameStr: "",

      examId: "",
      examName: "",
      createTime: "",
      showReport: 0,

      gradeId: "",
      gradeName: "",
      gradeList: [],

      subjectCode: "",
      subjectName: "",
      subjectList: [],

      classId: "",
      className: "",
      classList: [],

      // 数据统计
      average: {
        class: 0,
        grade: 0,
        rank: 0
      },
      excellent: {
        class: 0,
        grade: 0,
        rank: 0
      },
      pass: {
        class: 0,
        grade: 0,
        rank: 0
      },
      feeble: {
        class: 0,
        grade: 0,
        rank: 0
      },

      isReadOver: false,
      isHandle: false,
      handleList: [],
      videoDialogVisible: false,
      videoList: [
        {
          label: "如何制作答题卡",
          url: this.getOssUrl('oss-cn-hangzhou.aliyuncs.com/help-center/video/2.create-template.mp4')
        },
        {
          label: "有痕扫描上传步骤",
          url: this.getOssUrl('oss-cn-hangzhou.aliyuncs.com/help-center/video/3.scan-card.mp4')
        },
        {
          label: "如何创建单科考试",
          url: this.getOssUrl('oss-cn-hangzhou.aliyuncs.com/help-center/video/1.create-single-exam.mp4')
        }
      ],
      linkAct: -1,
      videoSrc: this.getOssUrl('oss-cn-hangzhou.aliyuncs.com/help-center/video/2.create-template.mp4')
    };
  },

  computed: {
    ...mapGetters({
      userInfo: "getUserInfo"
    })
  },

  mounted () {
    if (Array.isArray(this.userInfo.roles)) {
      this.roleNameStr = "";

      for (let item of this.userInfo.roles) {
        this.roleNameStr += item.roleName + " ";
      }
    }

    this.cardLeft = true;
    this.cardRight = true;

    this.schoolId = this.userInfo.schoolId;
  },

  methods: {
    pathToReportDetail () {
      this.$router.push("/exam/single/report/class/basic/" + this.examId);
    },

    //使用教程
    toTutorial () {
      this.$router.push("/new-home-help/index");
    },

    changeVideo (index) {
      this.linkAct = index;
      this.videoSrc = this.videoList[index].url;
      this.videoDialogVisible = true;
    },

    stopVideo () {
      let video = document.getElementById("video");
      video.pause();
      video.currentTime = 0;
      video.src = this.videoSrc;
    }
  },
  components: {
    NumberAnimated,
    EntraList: () => import("./components/entraList.vue")
  }
};
</script>
